<template>
  <template v-if="!accessToken">
    <main>
      <section class="login_please">
        <p>서비스 이용을 위해서</p>
        <p><span> 로그인</span> 또는 <span>회원가입</span>을 해주시기 바랍니다.</p>
        <button @click="router.push('/login')">로그인/회원가입</button>
      </section>
      <section class="ms_introduce">
        <img src="@/assets/images/ms_card.png" alt="멤버십카드이미지"/>
        <p class="ms_title">더파르나스 멤버십 <span>THE PARNAS MEMBERSHIP </span></p>
        <p>
          더파르나스는 그랜드 인터컨티넨탈 서울 파르나스와 웨스틴 서울 파르나스 그리고 파르나스 호텔 제주를 즐겨 찾으시는 고객님들께 객실과 레스토랑 할인 및 그 외 다양한 혜택을
          제공하는 프리미엄 멤버십입니다. 가입과 동시에
          사용하실 수 있는 호텔 숙박권과 레스토랑 이용권 등 다양한 혜택이 모바일 어플리케이션을 통해 제공됩니다.
        </p>
<!--        <p>-->
<!--          ※ 인터컨티넨탈 서울 코엑스는 2024년 7월 1일부로 영업을 종료하고, 약 1년 간의 전관 리모델링 공사를 거쳐 2025년 9월경 더욱 향상된 시설과 서비스를 갖춘 글로벌 리딩 브랜드의 새로운 호텔로 고객님을 찾아 뵐 예정입니다.-->
<!--        </p>-->
      </section>
      <section class="ms_inquire">
        <p>멤버십 문의</p>
        <dl>
          <dt>전화</dt>
          <dd>02-559-7645 (더파르나스팀)</dd>
        </dl>
        <dl>
          <dt>Email</dt>
          <dd>theparnas@parnas.co.kr</dd>
        </dl>
      </section>
    </main>
  </template>
  <template v-else>
    <main>
      <ul class="main_tab">
        <li
            v-for="{name, num} in tabList"
            :key="num"
            :class="{
            'on':currentTabNum === num,
            'off': currentTabNum !== num
          }"
            @click="changeTab({num: num, membershipId: null})"
            v-text="name">
        </li>
      </ul>
    </main>
    <MyMembership v-if="currentTabNum === 1" @changeTab="changeTab"/>
    <RestaurantHistory v-if="currentTabNum === 2"/>
    <Transition>
      <MembershipBenefit :initIndex="initIndex" v-if="currentTabNum === 3"
                         :membershipBusinessList="membershipBusinessList"/>
    </Transition>
    <!--    <div id="myModal1" class="modal-custom modal-custom-act" v-if="pushTermsAgree === null">-->
    <!--      &lt;!&ndash; Modal content &ndash;&gt;-->
    <!--      <div class="modal-content3">-->
    <!--        <div class="modal-body4">-->
    <!--          <h1>프로모션/이벤트 푸시 알림 동의</h1>-->
    <!--          <p>프로모션/이벤트 푸시알림 수신에 동의하시겠습니까? <br/>알림 수신에 동의하시면 [프로모션/이벤트 알림 수신]이 동의로 변경됩니다.-->
    <!--            <br><br>-->
    <!--            <span style="font-size: smaller;">※ '프로필 수정' 에서 동의여부를 변경할 수 있습니다.</span>-->
    <!--          </p>-->
    <!--          <div class="modal_btn_area">-->
    <!--            <button class="close-modal close-modal3" @click="patchPushAgree(false)">취소</button>-->
    <!--            <button class="close-modal close-modal4" @click="patchPushAgree(true)">동의</button>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!-- 파르나스 회원 전환 1차 팝업-->
    <div id="confirm-popup" class="layer-popup-wrap type-dim" v-if="showIntegrationModal">
      <div class="layer-popup">
        <div class="popup-header">
          <h4 class="tit">이제 하나의 통합 ID로 <br/>간편하게 이용하세요</h4>
        </div>
        <div class="popup-body">
          <div class="desc-wrap">
            <p>파르나스호텔의 다양한 서비스를 하나의 통합 ID로 간편하게 이용 하실 수 있도록 2025년 8월1일부터 통합회원제도를 도입합니다.</p>
            <p><br/>현재 사용하고 계신 계정을 통합회원(파르나스 리워즈 회원) 계정 으로 전환하시면, 하나의 ID로 기존 서비스를 이용하실 수 있으며, 파르나스 리워즈 회원에게만 제공되는 전용 상품, 할인, 적립 등 다양한 혜택까지 누릴 수 있습니다.</p>
            <!--            <p style="font-weight: bold;"><br/>문의 : 더파르나스팀 02-559-7645</p>-->
            <!--            <p style="font-weight: bold;padding-left: 2.5rem;">theparnas@parnas.co.kr</p>-->
          </div>
          <div class="contact-box">
            <button type="button" class="btn underline" onclick="window.open('https://seoul.intercontinental.com/hub/welcome/Notice/1281', '_blank' )">공지 확인하기</button>
          </div>
        </div>
        <div class="btn-wrap full">
          <button type="button" class="btn box-black-h64" @click="goWebLink()"><span>빠르게 통합하기</span></button>
          <button type="button" class="btn box-white-h64" @click="open2ndModal"><span>기존 계정으로 로그인하기</span></button>
          <div class="check-list out-check" v-if="this.integrationType === 'T'">
            <label for="check2">
              <input type="checkbox" v-model="checkedIntegration" id="check2" class="checkbox-deafult">
              <span class="checkmark"></span>
              <span class="checkbox-label">일주일 동안 열지 않음</span>
            </label>
          </div>
        </div>
        <button class="popup-close icon-close-black close" @click="closeIntegrationModal(1)" v-if="this.integrationType === 'T'"><span class="hidden">닫기</span></button>
      </div>
    </div>

    <!-- 파르나스 회원 전환 2차 팝업-->
    <div id="confirm-popup-sub" class="layer-popup-wrap type-dim" v-if="this.isShowIntegration2ndModal === true">
      <div class="layer-popup">
        <div class="popup-header">
          <h4 class="tit">잠깐!</h4>
        </div>
        <div class="popup-body">
          <div class="desc-wrap">
            <template v-if="this.integrationType === 'T'">
            <p>통합회원계정으로 전환하지 않으실 경우, 기존 ID를 이용하여 더파르나스 멤버십 App과 서비스는 동일하게 이용 가능합니다.</p>
            <p>단, 통합회원에게 제공되는 파르나스 리워즈 회원 혜택은 제공되지 않습니다. 그대로 진행하시겠습니까?</p>
            </template>
            <template v-else-if="this.integrationType === 'U'">
              <p>회원님은 현재 두 개의 ID를 보유 중입니다. 서비스 이용을 위해서는 통합계정으로 사용 하실 하나의 계정을 선택해 주셔야 합니다.</p>
              <p>하단의 통합하기 버튼을 클릭하신 후 하나의 계정을 빠르고 간편하게 선택해 주세요.</p>
            </template>

            <p style="font-weight: bold;"><br/>문의 : 02-559-7645(더파르나스팀)</p>
            <p style="font-weight: bold; padding-left: 2.5rem;">theparnas@parnas.co.kr</p>
          </div>
        </div>
        <div class="btn-wrap full">
          <button type="button" class="btn box-black-h64" @click="goWebLink()">
            <span>{{ integrationType === 'T' ? '전환하기' : integrationType === 'U' ? '빠르게 통합하기' : '' }}</span>
          </button>
          <button type="button" class="btn box-white-h64" @click="memberIntegration()" v-if="this.integrationType === 'T'"><span>기존 계정으로 로그인하기</span></button>
        </div>
        <button class="popup-close icon-close-black close" @click="closeIntegrationModal(2)" v-if="this.integrationType === 'T'"><span class="hidden">닫기</span></button>
      </div>
    </div>

  </template>

  <!--  공지사항 팝업-->
  <div id="myModal1" class="modal-custom modal-custom-act" v-if="noticePopups.length > 0">
    <div v-for="(item) in noticePopups" :key="item.id">
      <div class="modal-content5">
        <div class="modal-body5">
          <img style="width: 100%;"
               @click="noticeImageClick(item.param, item.popupType)"
               :src="`${resourcePath}/files/display/${item['attachFile']['id']}`" alt="">
          <div class="chk_close">
            <input type="checkbox" v-model="checkedNotices" id="chk_top"/>
            <label for="chk_top"><span>7일간 보지 않기</span></label></div>
          <div class="modal_btn_area2">
            <button class="close-modal close-modal5" @click="closeNotice(item.id)">
              <img src="@/assets/images/btn_closeX.png" alt="">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 멤버십 갱신안내 팝업 (기획서 5p) -->
  <!--
    구버전 앱 업데이트 안내는 여기서 띄우지 않는다.
    메인에도 두면 갱신 화면에서 '홈으로'를 눌렀을 때 메인에서 같은 팝업을 또 만나
    두 번 닫아야 한다. 안내는 갱신 진입 시점(RenewalMembership)에 한 번만 한다.
  -->
  <!--
    renewalNotice 는 이제 **노출 여부**만 정한다.
    확정 문구(수정안 슬라이드 2)에서 회원명·멤버십명·만료일이 빠져 팝업에 넘길 값이 없다.
    (조회 결과는 그대로 담아둔다 — 문구가 되돌아오면 다시 쓰고, 디버깅에도 쓰인다)
  -->
  <RenewalNoticePopup
      v-if="renewalNotice"
      @close="closeRenewalNotice"/>
</template>

<script>
/**
 * @root-page("/")
 */
import MyMembership from "@/views/main/MyMembership";
import MembershipBenefit from "@/views/main/MembershipBenefit";
import {mapGetters, mapActions, mapMutations, useStore} from "vuex";
import RestaurantHistory from "@/views/main/RestaurantHistory";
import RenewalNoticePopup from "@/components/renewal/RenewalNoticePopup";
import api from "@/api/modules/main"
import authApi from "@/api/modules/auth"
import renewalApi from "@/api/modules/renewal"
import {hideNoticeFor, isNoticeHidden} from "@/utils/renewalNotice"
import {initUserData} from "@/util";
import {useRouter} from "vue-router";
import dayjs from "dayjs";

export default {
  name: "MainVue",
  components: {
    RestaurantHistory,
    MyMembership,
    MembershipBenefit,
    RenewalNoticePopup,
  },
  computed: {
    resourcePath() {
      return process.env.VUE_APP_API_URL
    },
    ...mapGetters({
      accessToken: 'getAccessToken', //토큰
      autoLogin: 'getIsAutoLogin', // 자동 로그인 체크 여부
      membership: 'getUserMembershipInfo', // 멤버십 정보
      memberId: 'getMemberId', // 멤버 seq > memberMetaId 로 변경
      memberName: "getMemberName", // 유저 이름
      membershipTermsAgree: "getMembershipTermsAgree", // 멤버십 동의 여부
      banners: "getBannerPosition", // 베너 목록
      pushTermsAgree: "getPushTermsAgree", // 푸시 알림 동의 여부
      phoneAuthCheck: "getPhoneAuthCheck", // 핸드폰 필수 인증 동의여부
      relationSwiperMatchObj: "getRelationObjForSwiper", // 멤버십 혜택 스와이퍼 매칭 관계 객체,
      noticePopups: "getNoticePopups", // 공지사항 팝업 리스트
      memberType: "getMemberType", // 회원 유형 U : 통합회원 / R : Rewards / W : Web
      integrationType: "getIntegrationType" // 통합 유형 U : 통합대상 / T : 전환대상 / N : 미대상
    }),
    // 공지사항 팝업 리스트
    // noticePopups() {
    //   return localStorage.getItem('notices')
    // }
    showIntegrationModal() {
      // todo cs 때문에 변경 추후 삭제
      return false

      // todo cs 때문에 주석 추후 재공지
      // if (!this.isShowIntegrationModal) return false
      //
      // // 1) integrationType 체크
      // if (!(this.integrationType === 'U' || this.integrationType === 'T')) {
      //   return false
      // }
      //
      // // 전환 대상자만 일주일 다시 보지 않기 기능 적용
      // if (this.integrationType === 'T') {
      //
      //   // 2) 거부 기록이 있는지 확인
      //   const raw = localStorage.getItem('integrationRejected')
      //   let rejections = {}
      //   if (raw) {
      //     try {
      //       rejections = JSON.parse(raw)
      //     } catch {
      //       localStorage.removeItem('integrationRejected')
      //       rejections = {}
      //     }
      //   }
      //
      //   const record = rejections[this.memberId]
      //   if (record && dayjs(record.expired).isAfter(dayjs())) {
      //     // 만료일 이전이면 숨김
      //     return false
      //   }
      //   // 만료일 지났으면 기록만 지워두기
      //   if (record) {
      //     delete rejections[this.memberId]
      //     localStorage.setItem(
      //         'integrationRejected',
      //         JSON.stringify(rejections)
      //     )
      //   }
      // }
      //
      // // 그 외에는 모달 보여주기
      // return true
    }
  },
  async created() {
    try {
      // 메인으로 가기 전 핸드폰 미 인증 계정일 시, 핸드폰 인증 화면으로 팅김
      // if (!this.phoneAuthCheck) {
      //   this.router.replace('/phone-auth')
      // }
      // fcm 토큰 저장을 위한 메소드 저장
      window.afterLoginProcess = this.afterLoginProcess

      // 메뉴가 열려 있을 시를 대비
      this.setMenuClose()

      /*
        갱신안내 팝업 강제 노출 (`/?renewal=popup`).

        loginCheck() **앞**에 둔다. 주소창으로 바로 들어오면 history.state.back 이 null 이라
        loginCheck() 가 비로그인으로 처리하고 아래 블록 전체를 건너뛴다 — 로그인해 둔 상태에서도
        팝업을 볼 수 없었다. 확인용 훅이 정작 확인이 안 되던 셈이다.

        팝업 문구에 회원 정보가 없으므로(수정안 슬라이드 2에서 이름·멤버십명이 빠졌다)
        로그인 여부와 무관하게 띄워도 드러나는 값이 없다.
      */
      if (this.$route.query.renewal === "popup") {
        this.renewalNotice = true
      }

      // 자동 로그인 체크 여부
      if (this.loginCheck()) {
        // 자동로그인 on

        // 유저 이름, loginId, memberType, integrationType 셋팅
        await this.getUserInfo()

        // 250807 integrationoType U 일 경우 signin 페이지에서 로그인 처리 전에 적용 예정이었으나, api 추가 등 작업 복잡성으로 본 main.vue에서 처리하는 것으로 변경
        // if integrationType == "U"일 경우 logout 처리 및 login page로 튕김
        // if (this.integrationType === "U") {
        //   // 회원 정보 초기화 및 logout + login page로 이동
        //   await initUserData();
        //   if (this.$route.path !== '/login') this.$router.replace('/login');
        // }

        // 데이터 셋팅
        await this.getInfoToStartApp()

        // 갱신안내 팝업 (기획서 5p) — 갱신 대상자에게만 노출
        // todo 갱신안내 팝업 임시 차단 (2026-09-21 파르나스 요청). 다시 열 때 아래 주석만 풀면 된다.
        // await this.checkRenewalTarget()

        // 멤버십 가입 후, 멤버십 약관에 동의한 적 없으면 동의화면으로 튕김
        // todo : 임시로 유료가입 후 약관 동의 화면으로 이동 막음 250729
        // if (Array.isArray(this.membership) && this.membership.length > 0) {
        //   this.membership.forEach((item) => {
        //     if (!item.membershipTermsAgree) {
        //       this.router.replace({
        //         name: "MembershipTerms",
        //         query: {
        //           id: item.id
        //         }
        //       })
        //     }
        //   })
        // }
      }
    } catch (e) {
      console.log(e)
    } finally {
      // 공지사항 팝업 리스트
      await this.getNoticePopups()
    }
  },
  data() {
    return {
      router: useRouter(),
      store: useStore(),
      currentTabNum: 1,
      prevRoute: "",
      tabList: [
        {name: "나의 멤버십", num: 1},
        {name: "레스토랑 할인내역", num: 2},
        {name: "멤버십 혜택", num: 3},
      ],
      initIndex: 0,
      initMembershipName: '',
      isPushModalOpen: false,
      // 멤버십 갱신안내 팝업 (기획서 5p)
      // GET /v1/renewals/target 이 대상자일 때만 값을 채운다. null 이면 노출하지 않는다.
      renewalNotice: null,
      isMobile: {
        Android: function () {
          return navigator.userAgent.match(/Android/i) != null;
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
        }
      },
      membershipBusinessList: [],
      checkedNotices: false,
      isShowIntegrationModal: true, // 회원 통합, 전환 모달 보여주기 여부 1차
      isShowIntegration2ndModal: false, // 회원 통합, 전환 모달 보여주기 여부 2차
      loginUrl: process.env.VUE_APP_LOGIN_URL,
      checkedIntegration: false,
    }
  },
  watch: {
    currentTabNum() {
      if (this.currentTabNum === 1) {
        this.getMyMembershipInfo({available: true, withdrawal: false})
      }
    }
  },
  methods: {
    /**
     * 갱신 대상자 판정 (기획서 5p)
     *
     * 판정은 서버가 한다(회원의 멤버십 만료일 기준). 대상이 아니면 isTarget=false 로
     * 내려오므로 팝업을 띄우지 않는다.
     *
     * 회원명은 서버가 내려주지 않는다. 서버 로컬에 없는 값이라 팝업 문구 한 줄 때문에
     * 외부 회원조회를 한 번 더 부르게 되기 때문이다. 앱이 이미 가진 값으로 채운다.
     *
     * 화면 확인이 필요하면 `/?renewal=popup` 으로 강제 노출할 수 있다.
     */
    async checkRenewalTarget() {
      // 강제 노출(`/?renewal=popup`)은 created() 앞쪽에서 이미 처리했다. 조회까지 갈 필요가 없다.
      if (this.renewalNotice === true) return

      // "N일간 보지 않기"를 선택한 기간에는 조회 자체를 건너뛴다. (CMS 호출도 아낀다)
      if (isNoticeHidden(this.memberId)) return

      try {
        const {data} = await renewalApi.getRenewalTarget()
        this.renewalNotice = data?.isTarget
            ? {...data, memberName: data.memberName || this.memberName || "고객"}
            : null
      } catch (e) {
        // 갱신 안내는 부가 기능이다. 실패해도 메인 진입을 막지 않는다.
        this.renewalNotice = null
      }
    },

    /**
     * 갱신안내 팝업 닫기
     *
     * @param {Boolean} hide "N일간 보지 않기" 체크 여부
     */
    closeRenewalNotice(hide) {
      if (hide) hideNoticeFor(this.memberId)
      this.renewalNotice = null
    },
    ...mapMutations([
      "resetAuth",
      "resetMember",
      "setMemberName",
      "resetCouponStates",
      'setMenuClose',
      'setAccessToken',
      'setPushTermsAgree',
      'setNoticePopups',
      'setIntegrationType',
      'setLoginId',
      'setMemberType'
    ]),
    ...mapActions([
      "getMyMembershipInfo",
      'getNoticePopups'
    ]),
    afterLoginProcess(fcmToken) {
      // fcmToken 저장
      authApi.saveFcmToken(fcmToken)
          .catch(e => {
            console.log(e)
          })
    },
    async getInfoToStartApp() {
      try {
        // 디비 cms 멤버십 sync
        api.syncMembership()
            .catch(e => {
              console.log(e)
            })

        // 멤버십 정보
        if (this.router.options.history.state.back !== "/login") {
          await this.getMyMembershipInfo({available: true, withdrawal: false})
        }

        // native 브릿지
        // name: ParnasApp, method: login
        // 안드로이드인지, ios 인지
        if (this.isMobile.Android() || this.isMobile.iOS()) {

          if (this.isMobile.Android()) {
            // 안드로이드
            if (window.ParnasApp && window.ParnasApp.login) {
              await window.ParnasApp.login(this.memberId)
            }

          } else if (this.isMobile.iOS()) {
            // IOS
            window.webkit.messageHandlers.login.postMessage(this.memberId);
          }

        }
      } catch (e) {
        if (e.response.data.message) alert(e.response.data.message)
      }
    },
    changeTab({num, membershipId}) {
      if (membershipId) {
        // 매핑(util.js swiperSortOrder)에 없는 멤버십이면 null 이 온다. 그대로 Swiper 에 넘기면
        // mounted 에서 예외가 나 탭 전환까지 멈춘다(2026 상품 누락으로 실제 발생). 첫 슬라이드로 보낸다.
        const index = this.relationSwiperMatchObj[`${membershipId}`]
        this.initIndex = Number.isInteger(index) ? index : 0
      } else {
        this.initIndex = 0
      }
      this.currentTabNum = num
    },
    loginCheck() {
      if (this.autoLogin) {
        // 자동 로그인이 체크 되어 있을 때

        if (!this.accessToken) {
          // accessToken이 없으면 비 로그인 상태로 만들기
          initUserData()
          return false
        }

      } else {
        // 자동 로그인이 체크 되어 있지 않다면
        if (sessionStorage.getItem('isLogin') !== "true") {
          // 앱 실행 후 첫 메인 화면 진입했을 때 비 로그인상태로 만들기
          if (this.router.options.history.state.back === null || this.router.options.history.state.back === '/') {
            initUserData()
            return false
          }
        }
      }
      // 모든 조건을 충족한다면 true 반환
      return true
    },
    async patchPushAgree(value) {
      try {
        // 푸시 동의 여부 모달창이 열렸을 시, 서버 저장후, 결과값을 pushTermsAgree에 저장해 모달 닫기
        const {data: {pushTermsAgree}} = await api.patchPushAgree({pushTermsAgree: value})
        this.setPushTermsAgree({pushTermsAgree: pushTermsAgree})
      } catch (e) {
        this.setPushTermsAgree({pushTermsAgree: false})
        alert('오류로 인해 반영하지 못했습니다. 동의를 원하시면 프로필 동의에서 수정바랍니다.')
        throw e
      }
    },

    closeNoticeForSevenDays(id) {
      let hiddenNotices = localStorage.getItem('hiddenNotices') ?? '';
      if (hiddenNotices) {
        localStorage.setItem('hiddenNotices', JSON.stringify(
            [
              ...JSON.parse(hiddenNotices),
              {id: id, expiredDate: dayjs().add(7, 'day')}
            ]
        ))
      } else {
        // hiddenNotices
        localStorage.setItem('hiddenNotices', JSON.stringify([
              {id: id, expiredDate: dayjs().add(7, 'day')}
            ]
        ))
      }

    },
    closeNotice(id) {
      if (this.checkedNotices) {
        this.closeNoticeForSevenDays(id)
      }
      this.setNoticePopups({
        data: this.noticePopups.filter((item) => item.id !== id)
      })
      this.checkedNotices = false
    },
    noticeImageClick(param, type) {
      if (!param) return false
      switch (type) {
        case "NOTICE":
          this.router.push(`/notice/${param}`)
          break;
        case "PROMOTION":
          window.open(param)
      }
    },
    async getUserInfo() {
      let {data: {name, loginId, memberType, integrationType}} = await authApi.getMemberInfo()
        .catch(e => {
          if (e.response.data.status && e.response.data.status === 404) {
            this.doLogout()
          }
          console.log(e)
        })
      this.setMemberName({memberName: name})
      this.setLoginId({loginId: loginId})
      this.setMemberType({memberType: memberType})
      this.setIntegrationType({integrationType: integrationType})
    },

    memberIntegration() {
      // 모달 즉시 숨기기
      this.closeAllIntegrationModal()

      // 전환 대상자만 일주일 다시 보지 않기 기능 적용
      if (this.integrationType === 'T') {
        // 일주일 보지 않기 눌렀을때 이벤트
        if (this.checkedIntegration) {

          // localStorage에서 맵 불러오기
          const raw = localStorage.getItem('integrationRejected')
          const rejections = raw ? JSON.parse(raw) : {}

          // 거부: 회원별로 7일 뒤 만료일 저장
          rejections[this.memberId] = {
            expired: dayjs().add(7, 'day').toISOString()
          }
          localStorage.setItem(
              'integrationRejected',
              JSON.stringify(rejections)
          )
        }
      }
    },
    open2ndModal() {

      this.isShowIntegrationModal = false

      // todo : 8/10 버전 : 1차 팝업에서 기존 계정으로 로그인 클릭 시 2차 팝업 없이 그냥 로그인 처리
      // todo : 8/14 버전 : 1차 팝업에서 기존 계정으로 로그인 클릭 시 2차 팝업 노출
      // todo : 8/14 버전 : if 조건문 삭제 > 무조건 2차 팝업 띄우기
      // todo : 9/13 버전 : if 조건문 삭제 > 무조건 2차 팝업 띄우기
      // if (this.integrationType === 'T') {
      this.isShowIntegration2ndModal = true
      // }
    },
    // x 버든 닫기
    closeIntegrationModal(num) {
      // 1: 첫번째 팝업, 2: 두번째 팝업
      if (num === 1) {
        this.isShowIntegrationModal = false
      } else if (num === 2) {
        this.isShowIntegration2ndModal = false
      }

      this.memberIntegration();
    },
    async goWebLink() {
      // 외부 브라우저로 이동
      window.open(this.loginUrl, '_blank')
      this.closeAllIntegrationModal();
      await initUserData();
      if (this.$route.path !== '/login') this.$router.replace('/login');
    },
    // 통합 모달 전체 닫기
    closeAllIntegrationModal() {
      this.isShowIntegrationModal = false
      this.isShowIntegration2ndModal = false
    },
    // 메인에서 로그아웃
    async doLogout() {
      try {
        //fcmToken 삭제
        await authApi.removeFcmToken()

        //로그아웃
        await initUserData()
        if (this.$route.path !== '/') this.$router.replace('/')

      } catch (e) {
        if (e.response.data.message === "No value present") {
          await initUserData()
          if (this.$route.path !== '/') this.$router.push('/')
        }
        if (e.response.data.message) alert(e.response.data.message)
      }

    },
  },
};
</script>

<style>
.ms_introduce p:nth-of-type(3) {
  padding: 20px;
  line-height: 21px;
  font-size: 13px;
  color: #333;
  text-align: left;
}

/* popup */
#confirm-popup {
  z-index: 9998;
}

#confirm-popup-sub {
  z-index: 9999;
}

#confirm-popup .btn,
#confirm-popup-sub .btn {
  background-image: none;
  padding: 0;
}

#confirm-popup .hidden,
#confirm-popup-sub .hidden {
  display: block;
  position: absolute;
  overflow: hidden;
  margin: -1px;
  padding: 0;
  width: 1px;
  height: 1px;
  line-height: 1px;
  font-size: 1px;
  border: 0;
  clip: rect(0 0 0 0);
}

#confirm-popup h4,
#confirm-popup-sub h4 {
  margin: 0;
  line-height: 1.3;
}

.layer-popup-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.layer-popup-wrap.type-dim {
  background-color: rgba(0, 0, 0, 0.5);
}

.layer-popup-wrap .layer-popup {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: white;
  box-shadow: 0px 4px 28px rgba(54, 51, 48, 12);
  box-sizing: border-box;
  width: 90%;
  height: fit-content;
  min-height: 400px;
  padding: 28px 20px 28px;
  margin: 0;
  border-radius: 0;
}

.layer-popup-wrap .layer-popup .popup-header {
  font-weight: 600;
  line-height: 1.5;
  font-size: 18px;
  text-align: center;
  margin-bottom: 48px;
}

.layer-popup-wrap .layer-popup .popup-body {
  flex-grow: 1;
  margin-bottom: 3rem;
}

.layer-popup-wrap .layer-popup .popup-body .desc-wrap {
  margin-bottom: 20px;
}

.layer-popup-wrap .layer-popup .popup-body p {
  font-size: 14px;
  line-height: 1.54;
  font-weight: 400;
  color: #222222;
}

.layer-popup-wrap .layer-popup .popup-body .contact-box {
  display: block;
  text-align: right;
}

.layer-popup-wrap .layer-popup .popup-body .contact-box .btn.underline {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  position: relative;
  cursor: pointer;
  width: fit-content;
  margin: 0 auto;
}

.layer-popup-wrap .layer-popup .popup-body .contact-box .btn.underline::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: black;
  transform: scaleX(1);
}

.layer-popup-wrap .layer-popup .popup-body .contact-box .btn.underline::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: black;
  transform: scaleX(0);
  transition: .6s transform;
  transform-origin: left;
}

.layer-popup-wrap .layer-popup .popup-body .contact-box .btn.underline:hover::before {
  display: none;
}

.layer-popup-wrap .layer-popup .popup-body .contact-box .btn.underline:hover::after {
  transform: scaleX(1);
}

.layer-popup-wrap .layer-popup .btn-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
}

.layer-popup-wrap .layer-popup .btn-wrap button {
  font-weight: 500;
  line-height: 1.54;
  cursor: pointer;
  width: 100%;
  height: 64px;
  font-size: 18px;
}

.layer-popup-wrap .layer-popup .btn-wrap button.box-white-h64 {
  background-color: #fff;
  color: #000;
  border: 1px solid #ccc;
  transition: .2s background-color;
}

.layer-popup-wrap .layer-popup .btn-wrap button.box-white-h64:hover {
  background-color: #f8f8f8;
}

.layer-popup-wrap .layer-popup .btn-wrap button.box-black-h64 {
  background-color: #222;
  color: #fff;
  border: none;
  transition: .2s background-color;
}

.layer-popup-wrap .layer-popup .btn-wrap button.box-black-h64:hover {
  background-color: #111;
}

.layer-popup-wrap .layer-popup .popup-close {
  position: absolute;
  cursor: pointer;
  right: 20px;
  top: 35px;
  width: 24px;
  height: 24px;
}

.layer-popup-wrap .layer-popup .popup-close::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  width: 24px;
  height: 1px;
  background-color: black;
  transition: .3s transform;
}

.layer-popup-wrap .layer-popup .popup-close::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 24px;
  height: 1px;
  background-color: black;
  transition: .3s transform;
}

.layer-popup-wrap .check-list {
  margin-top: 20px;
}

.layer-popup-wrap .check-list label {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 0;
}

.layer-popup-wrap .check-list label .checkbox-label {
  color: black;
  font-size: 16px;
  font-weight: 400;
  vertical-align: middle;
  cursor: pointer;
}

.layer-popup-wrap .check-list input[type="checkbox"] {
  display: none;
}

.layer-popup-wrap .check-list input[type=checkbox].checkbox-deafult {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: #333;
  margin: 0;
}

.layer-popup-wrap .check-list input[type=checkbox].checkbox-deafult::before {
  border-radius: 50%;
}

.layer-popup-wrap .check-list input[type=checkbox] + .checkmark {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s ease;
  background-color: white;
}

.layer-popup-wrap .check-list input[type=checkbox] + .checkmark::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 4px;
  width: 5px;
  height: 8px;
  border: solid #ccc;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.layer-popup-wrap .check-list input[type=checkbox]:checked + .checkmark {
  background-color: #8a5660;
  border-color: #8a5660;
}

.layer-popup-wrap .check-list input[type=checkbox]:checked + .checkmark::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 4px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
</style>